module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedBlack.13e745d.woff";